// pages/FormViewerPage/sections/FormViewerBody.tsx — Router body form (wizard vs lead-only vs lengkap)
import React, { Suspense, useEffect } from 'react';
import { SimpleEmbedBody } from './SimpleEmbedBody';
import { FullFormBody } from './FullFormBody';
import { FormLoadingFallback } from '../../../App/LoadingScreens';
import { onIdle } from '../../../utils/idleCallback';
import type { FormViewerBodyProps } from './FormViewerBody/types';

// Langkah 2+ (analisis AI + dataset wilayah ±50KB) dipisah dari bundle awal
// (speed 2026-10-22): wizard payoff-nya besar karena step 1 tampil dulu.
const LazyWizardBody = React.lazy(() => import('./WizardBody').then(m => ({ default: m.WizardBody })));

const FormViewerBody: React.FC<FormViewerBodyProps> = (props) => {
    const isWizard = props.form?.addressInputMode === 'wizard';
    // Prefetch chunk step-2 saat user isi step 1 → transisi tetap instan.
    useEffect(() => {
        if (!isWizard) return;
        return onIdle(() => { void import('./WizardBody'); }, 2500);
    }, [isWizard]);
    if (isWizard) {
        return (
            <Suspense fallback={<FormLoadingFallback />}>
                <LazyWizardBody {...props} />
            </Suspense>
        );
    }
    return props.isSimpleEmbed ? <SimpleEmbedBody {...props} /> : <FullFormBody {...props} />;
};

export default FormViewerBody;
